import { Form } from 'antd';
import React from 'react';

import { ProjectSelect } from '../index';
// import { RowsFilterType } from '../types';

export interface IFieldProject<T> {
    disabled?: boolean;
    required?: boolean;
    name?: keyof T;
    // localFilters?: RowsFilterType;
    disabledListProject?: string[];
    filterFlexible?: string;
}

const FieldProject = React.forwardRef(
    <T extends Record<string, any>>({ required, name, ...restProps }: IFieldProject<T>, ref: React.Ref<any>) => {
        return (
            <Form.Item<T>
                label="Project"
                name={name as any}
                rules={[{ required: required, message: 'Please select project!' }]}
            >
                <ProjectSelect {...restProps} ref={ref} />
            </Form.Item>
        );
    },
) as <T extends Record<string, any>>(props: IFieldProject<T> & { ref?: React.Ref<any> }) => React.JSX.Element;

export default FieldProject;
